module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/~/socket.io-parser/~/isarray/index.js
// module id = ../../../../socket.io-parser/node_modules/isarray/index.js
// module chunks = 3